/*
  * If the dropdown is displayed, check whether it fits in the window,
  * and if not, set its style height to the available height so that
  * it will then get a scrollbar.
  * This directive should be added to the element with the "uib-dropdown" directive.
  */
/*@ngInject*/
const UIDropdownFitToWindowDirective = function () {
    /*
     * Check whether dropdownMenu fits in the window, and if not,
     * set its style height to the available height.
     */
    let fitToWindowFunction = function(dropdownMenu, absoluteOffsetTop) {
        let availableHeight = $(window).height() - absoluteOffsetTop;
        // clear any previous style height so that offsetHeight is recalculated
        dropdownMenu.css('height', '');
        if (dropdownMenu.outerHeight(true) > availableHeight) {
            // setting overflow=auto seems to be necessary if
            // the dropdown has the dropdown-append-to-body attribute.
            dropdownMenu.css('overflow', 'auto');
            dropdownMenu.css('height', availableHeight.toString() + 'px');
        }
    };
    let linkFunction = function ($scope, $element, $attr, $controller) {
        let element = $($element);
        $scope.$watch(function() {
                return $controller.isOpen();
            },
            function(newValue, oldValue) {
                let dropdownMenu;
                // if the dropdown is displayed, newValue will be true
                if (newValue !== oldValue && newValue) {
                    dropdownMenu = $controller.dropdownMenu;
                    if (dropdownMenu && dropdownMenu.length) {
                        fitToWindowFunction(dropdownMenu,
                                            element.offset().top + element.outerHeight(true));
                    }
                }
            })};
    return {
        restrict: 'A',
        require: '?^uibDropdown',
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiDropdownFitToWindow', UIDropdownFitToWindowDirective);
